import axios from "axios";

// const API_BASE = "http://localhost:5000/api";
const API_BASE = "https://seriea-analytics-node-express-react.vercel.app/api";

export const fetchTeams = () => axios.get(`${API_BASE}/teams`);
export const fetchMatches = () => axios.get(`${API_BASE}/matches`);
export const fetchReferees = () => axios.get(`${API_BASE}/referees`);
export const fetchGoals = () => axios.get(`${API_BASE}/goals`);
export const fetchMatchStats = () => axios.get(`${API_BASE}/match-stats`);
export const fetchTeamMatchStats = () =>
  axios.get(`${API_BASE}/team-match-stats`);
export const fetchTeamsInfo = () => axios.get(`${API_BASE}/teams-info`);
export const fetchTable = () => axios.get(`${API_BASE}/table`);
